import { useScreenSize, ScreenSizeProvider } from './ScreenSize'

export { useScreenSize, ScreenSizeProvider }

const ScreenSize = {
  useScreenSize,
  ScreenSizeProvider
}

export default ScreenSize
